import React from 'react';
import { NavLink } from "react-router-dom";

function MainMenu() {

    // const [setActiveIndex] = React.useState(0);
     
    const menu = [
        {
            'name' : 'Главная',
            'url' : '/'
        },
        {
            'name' : 'Новости',
            'url' : '/news/'
        },
        {
            'name' : 'Контакты',
            'url' : '/contact/'
        }
    ];

    return (
        <nav>
            <ul>
                {menu.map((value, i) => (
                    <li key={i}>
                        <NavLink
                        to={value.url}
                        onClick={ () => {
                            localStorage.removeItem('category');
                        }}
                        // onClick={() => setActiveIndex(i)}
                        // className={ActiveIndex === i ? 'active' : ''}
                        >
                        {value.name}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
   );
  }
  
  export default MainMenu;